var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.recipients.length)?_c('div',{staticClass:"caption no-recipients"},[_vm._v("None")]):_vm._l((_vm.recipients),function(email,i){return _c('div',{key:i,staticClass:"caption recipient"},[_vm._v(_vm._s(email))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }